<div id="wrapper" class="h-100vh p-3">
  <!-- Content Wrapper -->
  <div id="content-wrapper" class="d-flex flex-column ml-0">
    <!-- Main Content -->
    <div id="content">
      <div class="container-fluid">
        <div class="row logo">
          <div class="col-12 row no-gutters justify-content-center">
            <h1
              class="d-flex justify-content-center"
              style="flex-direction: column; align-items: center"
            >
              <img src="/assets/doctors-next/Logo.png" alt="Doctors Next" />
            </h1>
          </div>
        </div>
        <div class="text-center">
          <h1 class="h3">COLLABO Portalと連携</h1>
        </div>

        <div class="bgBox">
          <img
            src="/assets/doctors-next/logo-connect.svg"
            width="268"
            height="16"
            alt="DoctorsNext®⇔COLLABO Portal"
          />
          <div class="address">
            {{ email }}
          </div>
          <p>
            ご入力のメールアドレスは Doctors Next の提携サービス 「COLLABO
            Portal」で既に登録されています。ご登録情報を連携することにより、ご本人確認などの登録手続きを省略することができます。
          </p>
          <p class="buttonWrapper-link">
            <a
              href="https://collaboportal.com/"
              target="_blank"
              rel="noopener noreferrer"
              class="text-link"
              >COLLABO Portalとは</a
            >
          </p>
        </div>

        <div class="scrollBox">
          <section>
            <h2 class="title">外部サービスアカウント連携利用規約</h2>
            <h3 class="sub-title">第1条 利用規約の目的および適用</h3>
            <p>
              1.
              外部サービスアカウント連携利用規約（以下「本規約」といいます）は、株式会社コラボスクエア（以下「当社」といいます）がCOLLABO
              Portal（以下「本サービス」といいます）のサービスにおいて、他社が運営するサービス（以下「外部サービス」といいます）のアカウントを連携し、外部サービスを利用することに対して適用されるものです。外部サービスを利用する者は、本規約の内容を承認し、これに同意したものとみなされます。
            </p>
            <br />
            <h3 class="sub-title">
              第2条 外部サービスの利用及び連携の手続きについて
            </h3>
            <p>
              1.
              会員は、外部サービスのアカウント登録及び利用に際して、該当する外部サービスの運営者が定める利用規約に従うものとします。
            </p>
            <p>
              2.
              会員は､外部サービスとの連携時の注意事項および承諾事項はコラボポータル利用規約(<a
                href="https://dx.collaboportal.com/terms"
                target="_blank"
                rel="noopener noreferrer"
                class="text-link"
                >https://dx.collaboportal.com/terms</a
              >)の「第31条
              (外部サービスの利用)」､第32条（外部サービスとの連携）」に従うものとする｡
            </p>
            <p>
              3.
              会員が外部サービスにおけるアカウントの登録、管理等を行うにあたっては、全て自己の責任で行うものとし、管理不十分、使用上の過誤、第三者による使用等に起因するいかなる損害も、当社は責任を負わないものとします。
            </p>
            <p>
              4.
              外部サービスに連携を行う際に「ユーザー識別子」「メールアドレス」「姓名」「生年」「性別」「職種」「所属施設」を外部サービスに提供いたします。
            </p>
            <br />
            <h3 class="sub-title">第3条 外部サービス利用における責任</h3>
            <p>
              1.
              外部サービスのアカウント及びパスワードの不正使用や第三者の使用によって生じた会員または第三者への損害については、会員が全責任を負うものとします。また、このような事由により当社が損害を受けた場合、会員は当社に対して全ての損害を賠償するものとします。
            </p>
            <p>
              2.
              会員は、外部サービスを自己の責任において利用し、その利用により生じた損害やトラブルについて、当社は一切の責任を負わないものとします。
            </p>
            <br />
            <h3 class="sub-title">第4条 本規約の変更</h3>
            <p>
              1.
              本規約は予告なく内容を変更する場合があります。変更した内容は本ページへ掲示することにより、即時効力を生ずるものとします。
            </p>
          </section>
        </div>

        <div class="actions">
          <div
            *ngIf="errorMessages.login.password"
            class="row no-gutters mx-auto error-message"
          >
            <div class="col-md-12 col-12">
              <div class="alert alert-danger" role="alert">
                {{ errorMessages.login.password }}
              </div>
            </div>
          </div>
          <div class="password-form">
            <p>COLLABO Portalのパスワード</p>
            <input type="password" [(ngModel)]="password" />
          </div>
          <!-- TODO リンク先 -->
          <a [href]="getCportalPasswordResetUrl()" target="_blank"
            >COLLABO Portalのパスワードがご不明な方はこちら</a
          >

          <p>
            ご同意いただける場合は「COLLABO
            Portal」の利用規約をご確認の上、COLLABO Portal
            のパスワードをご入力いただき連携を完了させてください。
          </p>

          <button type="button" (click)="login()">同意して登録</button>

          <a class="text-link" (click)="gotoRegisterPage()"
            >別のメールアドレスで登録する</a
          >
        </div>
      </div>
    </div>
  </div>
</div>
